export const systemConstants = {
    infoEmail: "info@westernbid.com"
};